<div class='ili-panel start_wrapper_panel'>
  <div class="mb-20">
    <div>
      <mat-form-field class="w-full">
        <input matInput placeholder="Title" max="100" maxlength="100" [(ngModel)]="block.data.title" type="text"
          (change)="onChange($event)">
        <mat-hint align="end">{{block.data.title.length}} / 100</mat-hint>
      </mat-form-field>
    </div>
    <div *ngIf="tileType === 'safe_questionnaire' && needsEnum?.length" class="mb-20">
      <mat-form-field class="w-full">
        <mat-label>{{ 'Need' | translate }}</mat-label>
        <mat-select [value]="selectedNeedId" (selectionChange)="onNeedChange($event)">
          <mat-option value="">{{ 'None' | translate }}</mat-option>
          <mat-option *ngFor="let itm of needsEnum" [value]="itm.value">
            {{ itm.displayName | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div >
      <div class="flex flex-row gap-[0px]">
        <div class="flex w-full">
          <mat-form-field class="w-full">
            <input matInput max="10" placeholder="Color" [(ngModel)]="block.data.color" type="text"
              (change)="onChange($event)">
          </mat-form-field>
        </div>
        <div class="flex flex-40">
          <input type="color" style="height: 75%;" placeholder="Color" [(ngModel)]="block.data.color"
            (change)="onChange($event)">
        </div>
      </div>
    </div>
  </div>
  <div class="mb-20 flex flex-col lg:flex-row gap-[20px]">
    <div class="flex">
      <mat-checkbox value="true" [checked]="block.data.refresh" [(ngModel)]="block.data.refresh"
        (change)="onChange($event)"
        title="Check this box if this form should be cleared every time the end-user enters this tile.">Clear Fields
        after each submit</mat-checkbox>
    </div>
    <div class="flex">
      <mat-checkbox value="true" [checked]="block.data.close" [(ngModel)]="block.data.close" (change)="onChange($event)"
        title="Check this box if this form should be cleared every time the end-user enters this tile and it will close the form.">
        Clear and Close the Form</mat-checkbox>
    </div>
    <div class="flex">
      <mat-checkbox value="true" [checked]="block.data.formCollapse" [(ngModel)]="block.data.formCollapse"
        (change)="onChange($event)">Collapse</mat-checkbox>
    </div>
  </div>
</div>